export default __webpack_public_path__ + "static/media/refresh.8d2c6e57.png";